import {
  DashboardOutlined,
  Email,
  IntegrationInstructions,
  OndemandVideo,
  Restaurant,
  Article,
  Send,
  Group,
  BurstMode,
  Dashboard,
  Web,
  HistoryEdu,
  Sell,
} from '@mui/icons-material';
import { DEFAULT_ALLOWED_FORMAT } from '../../pages/Pages/constants';

export interface BoneLink {
  href?: string;
  hrefWithoutBrand?: string;
  label: string;
  icon: any;
  openBlank?: boolean;
  onClick?: () => any;
}

export const menuLinks: BoneLink[] = [
  {
    label: 'Article',
    href: '#/article/list?brand={BRAND}',
    hrefWithoutBrand: '#/article/list',
    icon: <Article />,
    openBlank: false,
  },
  {
    label: 'Diaporama',
    href: '#/slideshow/list?brand={BRAND}',
    hrefWithoutBrand: '#/slideshow/list',
    icon: <BurstMode />,
  },
  {
    label: 'Vidéo',
    href: '#/video/list?brand={BRAND}',
    hrefWithoutBrand: '#/video/list',
    icon: <OndemandVideo />,
    openBlank: false,
  },
  {
    label: 'Recette',
    href: config.FRONT_ONE_RECIPE,
    icon: <Restaurant />,
    openBlank: true,
  },
  {
    label: 'Page',
    href: `#/{BRAND}/page/${DEFAULT_ALLOWED_FORMAT.toLowerCase()}/list`,
    hrefWithoutBrand: `#/page/${DEFAULT_ALLOWED_FORMAT.toLowerCase()}/list`,
    icon: <Dashboard />,
  },
  {
    label: 'Orpheline',
    href: `#/orphanpage/list?brand={BRAND}`,
    hrefWithoutBrand: `#/orphanpage/list`,
    icon: <IntegrationInstructions />,
  },
  {
    label: 'Encart',
    href: '#/{BRAND}/card/list',
    icon: <Web />,
  },
  {
    label: 'Push',
    href: '#/mobilepush/list?brand={BRAND}',
    hrefWithoutBrand: '#/mobilepush/list',
    icon: <Send />,
  },
  {
    label: 'Newsletter',
    href: config.FRONT_ONE_NEWSLETTER,
    icon: <Email />,
    openBlank: true,
  },
  {
    label: 'People',
    href: config.FRONT_ONE_PEOPLE,
    icon: <Group />,
    openBlank: true,
  },
  {
    label: 'Auteurs',
    href: '#/authors/list',
    icon: <HistoryEdu />,
  },
  {
    label: 'Tags',
    href: '#/tag/list?brand={BRAND}',
    hrefWithoutBrand: '#/tag/list',
    icon: <Sell />,
  },
  {
    label: 'Dashboard',
    href: '#/dashboard?brand={BRAND}',
    hrefWithoutBrand: '#/dashboard',
    icon: <DashboardOutlined />,
  },
];
